module.exports = __webpack_public_path__ + "9a8e1a99060939e180f84b8f48e1a909.svg";